import { Component, Input } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';

@Component({
  selector: 'app-switch-input',
  template: `
    <div [ngClass]="containerClass">
      <label [ngClass]="labelClass" [for]="inputName" *ngIf="label && !labelAfter" class="mb-0 me-3">{{ label | transloco }}</label>
      <label [class]="small ? 'switch-sm' : 'switch'">
        <input [id]="inputName" type="checkbox" class="switch-checkbox" [formControl]="$any(control)"/>
        <span class="slider"></span>
      </label>
      <label [ngClass]="labelClass" [for]="inputName" *ngIf="label && labelAfter" class="mb-0 ms-2">{{ label | transloco }}</label>
    </div>
  `,
  styleUrls: ['./switch-input.component.scss']
})
export class SwitchInputComponent {
  @Input() label: string = null;
  @Input() control: AbstractControl = new FormControl();
  @Input() small = false;
  @Input() labelAfter = false;

  @Input() containerClass= 'd-flex align-items-center justify-content-between'
  @Input() labelClass= 'd-flex align-items-center justify-content-between'
  @Input() inputName = Math.random().toString();
}
